import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { INTERVENE_AUTOMATION_COPY } from '../../../constants/interveneAutomationCopy';
import { useInterveneAutomation } from '../../../context/InterveneAutomationContext';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function MessageActionButtons({
  buttons = [],
  onButtonClick,
  disabled = false,
}) {
  const {
    messageActionListSx,
    messageActionButtonSx,
    messageActionButtonPausedSx,
    automationPausedHintSx,
  } = useMessageStyles();
  const { isAutomationPaused } = useInterveneAutomation();

  if (!buttons.length) return null;

  return (
    <Box sx={messageActionListSx}>
      {buttons.map((button, index) => {
        const label = button.label || button.title || button.text || 'Button';
        const key = button.id || button.url || `${label}-${index}`;
        const isDisabled = disabled || isAutomationPaused || button.disabled;
        const tooltip = isAutomationPaused
          ? INTERVENE_AUTOMATION_COPY.automation.buttonPausedTooltip
          : label;

        const buttonNode = (
          <Box
            component="button"
            type="button"
            disabled={isDisabled}
            aria-disabled={isDisabled}
            title={!isAutomationPaused ? label : undefined}
            onClick={isDisabled ? undefined : () => onButtonClick?.(button, index)}
            sx={{
              ...messageActionButtonSx,
              ...(isDisabled ? messageActionButtonPausedSx : {}),
            }}
          >
            {label}
          </Box>
        );

        return (
          <Tooltip key={key} title={tooltip} arrow placement="top">
            <Box component="span" sx={{ display: 'block', width: '100%' }}>
              {buttonNode}
            </Box>
          </Tooltip>
        );
      })}

      {isAutomationPaused ? (
        <Typography sx={automationPausedHintSx}>
          {INTERVENE_AUTOMATION_COPY.automation.customerActionsPaused}
        </Typography>
      ) : null}
    </Box>
  );
}
